/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BuildingDetail model module.
 * @module model/BuildingDetail
 * @version 1.0.0
 */
class BuildingDetail {
    /**
     * Constructs a new <code>BuildingDetail</code>.
     * @alias module:model/BuildingDetail
     */
    constructor() { 
        
        BuildingDetail.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BuildingDetail</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BuildingDetail} obj Optional instance to populate.
     * @return {module:model/BuildingDetail} The populated <code>BuildingDetail</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BuildingDetail();

            if (data.hasOwnProperty('management_company_commission')) {
                obj['management_company_commission'] = ApiClient.convertToType(data['management_company_commission'], 'Number');
            }
            if (data.hasOwnProperty('shared_utility_expenses')) {
                obj['shared_utility_expenses'] = ApiClient.convertToType(data['shared_utility_expenses'], 'Number');
            }
            if (data.hasOwnProperty('misc_building_cost')) {
                obj['misc_building_cost'] = ApiClient.convertToType(data['misc_building_cost'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BuildingDetail</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BuildingDetail</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 管理会社委託費（建物＋賃貸管理含む）
 * @member {Number} management_company_commission
 */
BuildingDetail.prototype['management_company_commission'] = undefined;

/**
 * 共用部水道光熱費
 * @member {Number} shared_utility_expenses
 */
BuildingDetail.prototype['shared_utility_expenses'] = undefined;

/**
 * その他経費
 * @member {Number} misc_building_cost
 */
BuildingDetail.prototype['misc_building_cost'] = undefined;






export default BuildingDetail;

